(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('candrin-navigation')) {
  customElements.define('candrin-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const details = this.querySelector('details');
      const trigger = details.querySelector('summary');
      const close = (focus = false) => { clearTimeout(this.closeTimer); details.open = false; if (focus) trigger.focus(); };
      const isDesktop = () => matchMedia('(min-width: 750px) and (hover: hover)').matches;
      trigger.addEventListener('click', e => { if (isDesktop() && e.detail > 0) { e.preventDefault(); details.open = true; } }, options);
      trigger.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && isDesktop()) { clearTimeout(this.closeTimer); details.open = true; } }, options);
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && isDesktop() && !this.contains(document.activeElement)) this.closeTimer = setTimeout(() => close(), 180); }, options);
      this.addEventListener('keydown', e => { if (e.key === 'Escape' && details.open) { e.preventDefault(); close(true); } }, options);
      // Safari can report no new focus target while a link tap is still in progress.
      this.addEventListener('focusout', e => { if (e.relatedTarget && !this.contains(e.relatedTarget)) close(); }, options);
      this.querySelector('.cn-mega__close').addEventListener('click', () => close(true), options);
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) close(); }, options);
      // Mobile browser toolbars resize height during scrolling; only width changes close navigation.
      let viewportWidth = window.innerWidth;
      window.addEventListener('resize', () => { if (window.innerWidth !== viewportWidth) { viewportWidth = window.innerWidth; close(); } }, options);
      details.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(details.open)), options);
      trigger.setAttribute('aria-expanded', String(details.open));
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.closeTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
